import { Query } from 'react-apollo'
import loan, { Loan, LoanInput } from '../../graphql/queries/loan'
import withQuery from './withQuery'
import { GetProps } from '../../types'

class LoanQuery extends Query<Loan, LoanInput> {}

const LoanQueryCompleted = withQuery(loan)(LoanQuery)

export type LoanQueryProps = GetProps<typeof LoanQueryCompleted>
export type LoanQueryResult = Loan

export default LoanQueryCompleted



// WEBPACK FOOTER //
// ./src/components/queries/LoanQuery.tsx